export const internalLayoutViewConstants = {
    Building: 0,
    Project: 1,
    //add other views in future
};